import {WP_API_JWT_ROOT_URL, WP_API_JWT_VALIDATE_ROOT_URL} from "./rest-api-addr.js";

import axios from 'axios';
import jwt from 'jsonwebtoken';
import {_} from 'underscore';

class AuthRest  {
  constructor() {
  }

  // ---- requetes rest
  static requestToken(username, pw) {
    return axios.post(WP_API_JWT_ROOT_URL, {
        username : username,
        password : pw
    });
  }

  static authCookieName() {
    return 'jh2rtelL6RhUyG7rehk6oYgt';
  }

  static authHeader() {
    let user = this.readAuthCookie();
    if(user && user.token) {
      return { 'Authorization' : 'Bearer' + user.token }
    }

    return null;
  }

  static setAuthCookie(data) {
    let hours = 60 * 60 * 2; // 3h
    window.$cookies.set(this.authCookieName(), data, hours);
  }

  static readAuthCookie() {
    let data = null;
    if(this.hasAuthCookie()) {
      data = window.$cookies.get(this.authCookieName());
    }

    return data;
  }

  static hasAuthCookie() {
    return (window.$cookies.isKey(this.authCookieName()) == true);
  }

  static removeAuthCookie() {
    if(this.hasAuthCookie()) {
      window.$cookies.remove(this.authCookieName());
    }
  }

  static isValidAuthToken(token) {
    return true;
  }

  static readAuthExpirationDate(token) {
    if(token) {
      jwt.decode(token,
        { maxAge:true })
    }
  }

  static decodeAuthTokenPayload(token) {
    if(token) {
      let data = jwt.decode(token, {complete: true});
      if(data) {
          return data.payload;
      }
    }
    return null;
  }

  static autoCheckAuthCookie() {
    if(this.hasAuthCookie()) {
      let data = this.readAuthCookie();
      if(data.token) {
        // check date if date is invalid => removecookie
        return data;
      }
    }

    return null;
  }

}

export default AuthRest;



// WEBPACK FOOTER //
// ./src/helpers/auth-rest-func.js